module.exports = __webpack_public_path__ + "static/img/on.cf1ff99d.png";